(function () {
  // 可见卡片数:移动端(≤749)显示 2,桌面 4。随窗口宽度自适应。
  function getVisible() {
    var w = window.innerWidth || document.documentElement.clientWidth || 1024;
    return w <= 749 ? 2 : 4;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function setup(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.__pbsInited) return;
    root.__pbsInited = true;

    var viewport = root.querySelector("[data-pbs-viewport]");
    var track = root.querySelector("[data-pbs-track]");
    if (!(viewport instanceof HTMLElement) || !(track instanceof HTMLElement)) return;

    var n = parseInt(root.getAttribute("data-pbs-product-count") || "0", 10);
    var visible = getVisible();
    if (!n || n < 2) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-pbs-slide]"));
    var total = slides.length;
    if (!total) return;

    track.style.setProperty("--pbs-slide-total", String(total));

    var current = parseInt(root.getAttribute("data-pbs-start-index") || String(n), 10);
    current = clamp(current, 0, total - visible);

    var dragging = false;     // 仅在移动超过阈值、真正进入拖拽后为 true
    var pointerDown = false;   // 指针按下中(可能是点击,也可能是拖拽)
    var pointerId = null;
    var startX = 0;
    var startIndex = 0;
    var DRAG_START = 6;        // 移动 >6px 才算拖拽,否则视为点击(放行 <a> 跳转,不重排不闪)

    function slidePercent() {
      return 100 / total;
    }

    function applyTransform(animate) {
      track.style.transition = animate ? "" : "none";
      track.style.transform = "translateX(" + -(current * slidePercent()) + "%)";
      if (!animate) {
        track.offsetHeight;
        track.style.transition = "";
        updateSlots();
      } else {
        setTimeout(updateSlots, 80);
      }
    }

    function updateSlots() {
      for (var i = 0; i < slides.length; i++) {
        var slot = i - current;
        if (slot >= 0 && slot < visible) {
          slides[i].setAttribute("data-pbs-slot", String(slot));
        } else {
          slides[i].removeAttribute("data-pbs-slot");
        }
      }
    }

    function wrapIfNeeded() {
      var needsWrap = false;
      if (current >= 2 * n) {
        current -= n;
        needsWrap = true;
      } else if (current < n) {
        current += n;
        needsWrap = true;
      }
      if (needsWrap) {
        root.classList.add("pbs--no-transition");
        applyTransform(false);
        root.offsetHeight;
        root.classList.remove("pbs--no-transition");
      }
    }

    function goNext() {
      current += 1;
      applyTransform(true);
    }

    function goPrev() {
      current -= 1;
      applyTransform(true);
    }

    track.addEventListener("transitionend", function (e) {
      if (e.propertyName !== "transform") return;
      wrapIfNeeded();
    });

    viewport.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        goNext();
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        goPrev();
      }
    });

    // 翻页箭头(桌面端按钮);prev=上一组 goPrev,next=下一组 goNext
    var prevBtn = root.querySelector("[data-pbs-prev]");
    var nextBtn = root.querySelector("[data-pbs-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { goPrev(); });
    if (nextBtn) nextBtn.addEventListener("click", function () { goNext(); });

    viewport.addEventListener("dragstart", function (e) {
      e.preventDefault();
    });

    viewport.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      if (e.target instanceof Element && e.target.closest(".pbs__fav,.pbs__buy")) return;
      pointerDown = true;
      dragging = false;
      pointerId = e.pointerId;
      startX = e.clientX;
      startIndex = current;
      // 不在此处 setPointerCapture:否则 click 会被劫持到 viewport,卡片内 <a>(图片/标题)无法跳转。
    });

    viewport.addEventListener("pointermove", function (e) {
      if (!pointerDown || pointerId !== e.pointerId) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) < DRAG_START) return;   // 还没到拖拽阈值 → 当作潜在点击,不动 track
        dragging = true;
        track.classList.add("is-dragging");
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var vw = viewport.getBoundingClientRect().width;
      if (!vw) return;
      var next = startIndex - dx / vw;
      track.style.transform = "translateX(" + -(next * slidePercent()) + "%)";
    });

    function onEnd(e) {
      if (!pointerDown || pointerId !== e.pointerId) return;
      pointerDown = false;
      pointerId = null;
      if (!dragging) return;   // 纯点击:不拦截、不重排 → <a> 正常跳转、Buy 不闪
      dragging = false;
      track.classList.remove("is-dragging");
      var dx = e.clientX - startX;
      var threshold = Math.min(64, viewport.getBoundingClientRect().width * 0.08);
      if (dx < -threshold) {
        goNext();
      } else if (dx > threshold) {
        goPrev();
      } else {
        applyTransform(true);
      }
    }

    viewport.addEventListener("pointerup", onEnd);
    viewport.addEventListener("pointercancel", onEnd);

    /* 心形收藏逻辑统一由全站 parans-wishlist.js 委托处理（写入 localStorage['wishlistItem']）。
       此处不再绑定视觉切换，避免 stopPropagation 拦截全站委托 / 双重触发。 */

    var resizeTimer = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nv = getVisible();
        if (nv === visible) return;
        visible = nv;
        current = clamp(current, n, 2 * n - 1);
        root.classList.add("pbs--no-transition");
        applyTransform(false);
        root.offsetHeight;
        root.classList.remove("pbs--no-transition");
      }, 150);
    });

    root.classList.add("pbs--no-transition");
    applyTransform(false);
    root.offsetHeight;
    root.classList.remove("pbs--no-transition");
  }

  function initAll(scope) {
    var root = scope instanceof HTMLElement ? scope : document;
    root.querySelectorAll("[data-pbs]").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target instanceof HTMLElement) {
      var nodes = e.target.querySelectorAll("[data-pbs]");
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].__pbsInited = false;
      }
      initAll(e.target);
    }
  });
})();
